exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .svg-text {\n    text-align: left;\n    font: Helvetica;\n    color: #5bad41;\n    font-weight: bold;\n    transform: scale(0.7);\n} */\n\n.small {\n    font: 12px Helvetica;\n    font-weight: bold;\n    /* fill: #5bad41; */\n}\n\n@media only screen and (max-width: 600px) {\n    .svg-text {\n        transform: scale(0.85);\n    }\n}\n", ""]);

// exports
